<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="30">
        <el-col :span="18">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Campaigns</h4>
            </div>

            <data-tables-server
              class="table-shopping"
              style="width: 100%"
              :data="automations"
              :current-page="1" 
              :tool-bar="false"
              :total="total"
              @query-change="getCampaigns"
              :page-size="10"
              :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }"
            >
              <el-table-column min-width="140" label="Name" prop="email_address">
                <template slot-scope="props">
                  <span>{{props.row.settings.title}}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="50" label="Sent" prop="email_address">
                <template slot-scope="props">
                  <span>{{props.row.emails_sent}}</span>
                </template>
              </el-table-column>
               <el-table-column min-width="50" label="Open" prop="email_address">
                <template slot-scope="props">
                  <span v-if="props.row.report_summary">{{props.row.report_summary.opens}}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="50" label="Clicks" prop="email_address">
                <template slot-scope="props">
                  <span v-if="props.row.report_summary">{{props.row.report_summary.clicks}}</span>
                </template>
              </el-table-column>
        <el-table-column min-width="50" label="Status" prop="email_address">
                <template slot-scope="props">
                  <span >{{props.row.status}}</span>
                </template>
              </el-table-column>
            </data-tables-server>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import api from "./api";
import moment from "moment"
export default {
  data() {
    return {
      automations: [],
      total: 0
    };
  },
  methods: {
    getAutmations(q) {
        console.log(q)
        var page = 1;
      var pageSize = 10;
      api
        .getAutomations({
          count: q.pageSize,
          offset: (q.page - 1) * q.pageSize,
          sort_field: "send_time",
          sort_dir: "DESC",
          status:'sending'
        })
        .then(response => {
          this.automations = response.data.automations;
          this.total = response.data.total_items;
        });
    }
  },

  async mounted() {
    this.getAutmations({ count: 10, offset: 0 });
  }
};
</script>
<style>
.item {
  margin-top: 10px;
  margin-right: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/Mailchimp/Automations.vue